import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-10 sm:py-16 px-4 bg-brand-warm" data-id="element-185">
      <div className="max-w-xl mx-auto text-center space-y-4 sm:space-y-6" data-id="element-186">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-base sm:text-lg text-brand-text-main font-medium" data-id="element-187">
          Sono le 19:30 di un martedì qualunque.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-base sm:text-lg text-brand-text-main font-medium" data-id="element-188">
          Sei appena tornato a casa dopo una giornata pesante.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-base sm:text-lg text-brand-text-main font-medium" data-id="element-189">
          Apri il frigorifero.
          <br data-id="element-190" />
          Lo fissi trenta secondi.
          <br data-id="element-191" />
          Lo richiudi.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-lg sm:text-2xl font-serif font-bold text-brand-olive" data-id="element-192">
          Hai tutto — e non hai niente.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-sm sm:text-lg text-brand-text-muted" data-id="element-193">
          Non hai voglia di cucinare qualcosa di elaborato.
          <br data-id="element-194" />
          Non vuoi ordinare ancora una pizza.
          <br data-id="element-195" />E soprattutto non vuoi sentirti pesante e gonfio domani mattina.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-sm sm:text-lg text-brand-text-main font-medium" data-id="element-196">
          Così fai la stessa cosa di sempre.
          <br data-id="element-197" />
          Qualcosa di veloce. Qualcosa di improvvisato.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-sm sm:text-lg text-brand-text-muted" data-id="element-198">
          E mentre mangi, pensi:
        </motion.p>

        <motion.blockquote initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-xl sm:text-3xl font-serif font-bold text-brand-olive italic my-6 sm:my-8" data-id="element-199">
          "Da lunedì cambio."
        </motion.blockquote>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-sm sm:text-lg text-brand-text-main font-medium" data-id="element-200">
          Ma lunedì arriva. E riparte tutto da capo.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white p-5 sm:p-8 rounded-2xl shadow-sm border border-brand-sage/20 mt-8 sm:mt-10" data-id="element-201">
          <h3 className="text-lg sm:text-2xl font-bold text-brand-text-main mb-3 sm:mb-4" data-id="element-202">
            Non è colpa tua.
          </h3>
          <p className="text-sm sm:text-base text-brand-text-muted mb-2" data-id="element-203">
            Il problema non è la tua mancanza di volontà.
          </p>
          <p className="text-brand-olive font-bold text-base sm:text-lg" data-id="element-204">
            Il problema è che nessuno ti ha mai dato un sistema semplice e
            concreto da seguire davvero.
          </p>
        </motion.div>
      </div>
    </section>;
}